import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';

interface MandatoryScheduleCtaModalProps {
  open: boolean;
  onConfirm: () => void;
}

/**
 * Modal obligatorio mostrado a psicólogas NZ en estado "new" apenas terminan el paso
 * simulado de carga de horarios del tour de Agenda. Corta ahí el resto de la guía (no
 * entran al tour de agendamiento simulado) para llevarlas directo a cargar su
 * disponibilidad real. No se puede cerrar sin usar el CTA — a propósito.
 */
const MandatoryScheduleCtaModal: React.FC<MandatoryScheduleCtaModalProps> = ({ open, onConfirm }) => {
  return (
    <Dialog open={open} onOpenChange={() => { /* no dismissable: solo se cierra con el CTA */ }}>
      <DialogContent
        data-testid="mandatory-schedule-cta-modal"
        className="sm:max-w-[28rem] p-0 overflow-hidden"
        onEscapeKeyDown={(e) => e.preventDefault()}
        onPointerDownOutside={(e) => e.preventDefault()}
        onInteractOutside={(e) => e.preventDefault()}
      >
        <DialogHeader className="px-6 pt-6 pb-2">
          <DialogTitle className="text-[1.125rem] font-semibold text-[#4a3d73]">
            ¡Ahora configurá tu disponibilidad real!
          </DialogTitle>
        </DialogHeader>
        <div className="px-6 pb-5 text-[0.875rem] text-gray-600 leading-relaxed space-y-2">
          <p className="m-0">
            Ya aprendiste cómo se configura tu disponibilidad con un horario ficticio!
          </p>
          <p className="m-0">
            Ahora, para que nuestros pacientes puedan empezar a agendar con vos, necesitás
            configurar tu horario de disponibilidad real.
          </p>
        </div>
        <div className="px-6 py-4 border-t border-gray-100 bg-gray-50 flex justify-end">
          <button
            type="button"
            data-testid="mandatory-schedule-cta-confirm"
            onClick={onConfirm}
            className="px-5 py-2 rounded-full text-sm font-semibold text-white border-none cursor-pointer transition-all hover:brightness-90"
            style={{ background: '#6D57BC' }}
          >
            Vamos a configurarla
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default MandatoryScheduleCtaModal;
